var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAiGenerated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2048 512",
    role: "img",
    "aria-label": "AI Generated",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 0H1792A256 256 0 0 1 1792 512H256A256 256 0 0 1 256 0Z",
    fill: "#888888"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    dominantBaseline: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 365,
    y: 256,
    fontSize: 190
  }, "AI"), /*#__PURE__*/React.createElement("text", {
    x: 680,
    y: 256,
    fontSize: 150
  }, "GENERATED"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAiGenerated);
export default __webpack_public_path__ + "static/media/icon_ai_generated.1e9d0653a764345ecea02c6abcb3a5dc.svg";
export { ForwardRef as ReactComponent };